import React from 'react';
import { Link } from 'react-router-dom';
import { apTheme, hubCardHoverShadow, hubCardIconStyles, type HubCardIconTone } from '../../utils/agentPlatformTheme';

type Props = {
  title: string;
  description: string;
  to: string;
  enabled: boolean;
  iconTone: HubCardIconTone;
  icon: React.ReactNode;
};

const cardSurface = (enabled: boolean, iconTone: HubCardIconTone) =>
  `group relative rounded-2xl border bg-white p-6 shadow-lg transition-all duration-300 ${
    enabled
      ? `border-stone-200/80 hover:-translate-y-1 hover:shadow-xl cursor-pointer ${hubCardHoverShadow[iconTone]}`
      : 'border-stone-100 opacity-55 grayscale cursor-default'
  }`;

export const AgentPlatformHubCard: React.FC<Props> = ({
  title,
  description,
  to,
  enabled,
  iconTone,
  icon,
}) => {
  const content = (
    <>
      <div
        className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl ${hubCardIconStyles[iconTone]}`}
      >
        {icon}
      </div>
      <h2 className="text-lg font-semibold text-stone-900 mb-2">{title}</h2>
      <p className="text-sm text-stone-600 leading-relaxed mb-4 min-h-[2.75rem]">{description}</p>
      {enabled ? (
        <span className={`inline-flex items-center gap-1 text-sm font-semibold ${apTheme.link}`}>
          Abrir
          <span className="transition-transform group-hover:translate-x-0.5" aria-hidden>
            →
          </span>
        </span>
      ) : (
        <span className="text-sm text-stone-400">Não licenciado</span>
      )}
    </>
  );

  if (enabled) {
    return (
      <Link
        to={to}
        className={`block no-underline text-stone-900 hover:text-stone-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500/40 focus-visible:ring-offset-2 rounded-2xl ${cardSurface(enabled, iconTone)}`}
      >
        {content}
      </Link>
    );
  }

  return <div className={cardSurface(enabled, iconTone)}>{content}</div>;
};
